import React, { useEffect } from 'react';
import { pluralize } from 'src/scripts/utils/helpers';
import { ServerPlpData } from 'src/@types/window-extended';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import MultiCollectionToggle from './MultiCollectionToggle';
import { SearchProductsSortFragment } from 'src/generated/product-service-graphql';
import { useSearchParamHelpers } from '../../_shared/react-hooks';
import { SORT_BY_KEY, getSortStyle } from './sorting-utils';
import aloDropdownStyles from '../../_shared/ui-components/YogaUI/alo-ui/AloDropdown/styles.module.scss';
import sortDropdownStyles from '../../_shared/ui-components/YogaUI/alo-ui/AloDropdown/sorting.module.scss';
import { Sorting } from './Sorting';
import { stickyPLPFilterControls } from 'src/scripts/utils/dom';
import { useMediaQuery } from '@material-ui/core';

const PlpPageHeader = ({
  title,
  resultsQuantity = 0,
  totalAppliedFilterCount,
  filtersCount,
  openPlpFiltersDrawer,
  sortOptions,
  isLoading,
  clearAllFilters,
}: PlpPageHeaderProps) => {
  const desktopView = useMediaQuery('(min-width: 991.98px)');
  const { searchParams } = useSearchParamHelpers(window.location.search, { replace: true });
  const serverPlpData: ServerPlpData | undefined = window.server_plp_data;
  const initialOption = sortOptions.find((option) => option.value === searchParams.get(SORT_BY_KEY));
  const sortValue = initialOption
    ? { key: initialOption.value, text: initialOption.label }
    : { key: 'DEFAULT', text: !desktopView ? 'SORT' : '' };

  useEffect(() => {
    stickyPLPFilterControls();
  }, []);

  const productCount = (
    <>
      <div className="plp-product-count body center">
        {!isLoading
          ? pluralize(resultsQuantity, `${!!totalAppliedFilterCount ? 'matching ' : ''}product`)
          : `Fetching results...`}
      </div>
      {resultsQuantity === 0 && !isLoading && !!totalAppliedFilterCount && (
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <button className="reset-filter-button" onClick={clearAllFilters}>
            Reset Filters
          </button>
        </div>
      )}
    </>
  );

  return (
    <>
      <div className="plp-header nativeapp-hide">
        <h1 className="h2">{title}</h1>
        {serverPlpData?.description && (
          <p className="plp-description body" dangerouslySetInnerHTML={{ __html: serverPlpData.description }}></p>
        )}
        {desktopView ? productCount : null}
      </div>
      {!desktopView ? <MultiCollectionToggle /> : null}
      <div className="sticky-list-controls">
        <div className="controls">
          {filtersCount > 0 && !desktopView && (
            <button className="mobile-filters-trigger" onClick={openPlpFiltersDrawer}>
              <span>{`FILTERS ${totalAppliedFilterCount ? `(${totalAppliedFilterCount})` : ''}`}</span>
              <span style={{ color: 'rgba(0, 0, 0, 0.54)', fontSize: 0 }}>
                <ExpandMoreIcon className={aloDropdownStyles.expandMoreIcon} />
              </span>
            </button>
          )}
          {sortOptions.length > 0 ? (
            <Sorting
              value={sortValue}
              dropdownItems={sortOptions.map((sortOption) => ({
                key: sortOption.value,
                text: sortOption.label,
              }))}
              {...(!desktopView
                ? {
                    wrapperClass: aloDropdownStyles.sorting,
                  }
                : {
                    wrapperClass: sortDropdownStyles.sorting,
                    labelPrefix: 'Sort by',
                    hasBorder: false,
                    MUIAutocompleteProps: {
                      classes: getSortStyle(sortValue),
                    },
                  })}
            />
          ) : null}
        </div>
      </div>
      {!desktopView ? productCount : null}
    </>
  );
};

export default PlpPageHeader;

interface PlpPageHeaderProps {
  title: string;
  resultsQuantity?: number;
  filtersCount: number;
  totalAppliedFilterCount: number;
  openPlpFiltersDrawer: () => void;
  sortOptions: SearchProductsSortFragment[];
  isLoading: boolean;
  clearAllFilters: () => void;
}
